import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=1fc1e0b3&scoped=true&"
import script from "./Sort.vue?vue&type=script&lang=ts&"
export * from "./Sort.vue?vue&type=script&lang=ts&"
import style0 from "./Sort.vue?vue&type=style&index=0&id=1fc1e0b3&lang=less&scoped=true&"
import style1 from "./Sort.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1e0b3",
  null
  
)

export default component.exports